import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BaseDestroy } from 'nera-common/angular';
import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from 'environments/environment';
import { NewDeviceLoginEvent } from './core/models/iam-signalr-events.model';
import { SignalRService } from './core/services/signalr.service';
import { ToastService } from './core/services/toast.service';
import { ConsentGateService } from './features/consent/consent-gate.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
})
export class AppComponent extends BaseDestroy implements OnInit {
    private readonly _signalR = inject(SignalRService);
    private readonly _toast = inject(ToastService);
    private readonly _consentGate = inject(ConsentGateService);

    ngOnInit(): void {
        // PFL-2569/#3306: first-login Terms + AI-processing acceptance gate —
        // re-checks on every authenticated `user$` emission, once per user.
        this._consentGate.init();

        // PFL-394 Task 10 — toast on new device login (oauth-hub).
        // Skip when optional hubs are disabled (local gate / missing BE hubs).
        if (environment.signalR.optionalHubsEnabled === false) {
            return;
        }

        this._signalR
            .getNewDeviceLogin$()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((evt: NewDeviceLoginEvent) => {
                const where = evt.deviceName ?? evt.userAgent ?? 'an unknown device';
                const from = evt.ipAddress ? ` (${evt.ipAddress})` : '';
                this._toast.warning(`New login from ${where}${from}`, 'View Sessions', 0);
                // Snackbar action click navigates — wired via a simple click handler below.
                // ToastService doesn't expose action streams, so fallback: persistent toast
                // and the user can click the sessions menu item.
            });
    }

}
